export const formStyles = {
    inputMargin: 20,
    submitColor: '#d3b311eb'
}